// firebaseConfig.js
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyA9AjkcXNyJ-nEFZlgZm_cDJv9qO9L7ZPs",
  authDomain: "techdispatch-fa762.firebaseapp.com",
  projectId: "techdispatch-fa762",
  storageBucket: "techdispatch-fa762.firebasestorage.app",
  messagingSenderId: "936443635568",
  appId: "1:936443635568:web:fcaabf0d9307768766d1b5",
  measurementId: "G-BJDFTHVRT8",
};

const app = initializeApp(firebaseConfig);

export default app;
